module.exports = __webpack_public_path__ + "b7c9e1e479de3b53f1e4e30ebac2403a.woff";


//////////////////
// WEBPACK FOOTER
// ../~/slick-carousel/slick/fonts/slick.woff
// module id = 390
// module chunks = 7